import moment from 'moment'

export function dateToUnixTime (date, format) {
  if (typeof format === 'undefined') {
    format = 'YYYY-MM-DD'
  } else {
    // to moment time format
    format = format.replace('HH:MM:SS', 'HH:mm:ss')
  }

  return moment(date, format, true).format('X')
}

export function unixTimeToDate (unix, format = 'YYYY-MM-DD') {
  return moment(unix).format(format)
}

export function unixTimeToDateTime (unix, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(unix).format(format)
}
